import { Flex } from "antd";

export const ColumnComponent = ({ children, style = {}, ...props }) => {
  return (
    <Flex
      vertical
      style={{
        width: "100%",
        ...style,
      }}
      {...props}
    >
      {children}
    </Flex>
  );
};
